import React, { useEffect, useState } from 'react';
import { bool, func } from 'prop-types';
import { Button } from '@thd-olt-component-react/button';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Input } from '@thd-olt-component-react/input';
import * as analytics from '../../../ratings-reviews-analytics';

export const Search = ({ noResults, onSearch, searchTerm }) => {
  const [searchPillText, setSearchPillText] = useState(searchTerm);
  const [searchText, setSearchText] = useState(searchTerm || '');
  const onSubmit = (e) => {
    e.preventDefault();
    setSearchPillText(searchText);
    analytics.track('event', {
      origin: 'ratings and reviews',
      location: 'search',
      keyword: searchText,
      eventType: 'text'
    });
  };

  useEffect(() => {
    if (!searchPillText) {
      setSearchText('');
      onSearch(null);
      return;
    }
    onSearch(searchPillText);
  }, [searchPillText]);

  return (
    <div className="ratings-reviews__search">
      <Col className="ratings-reviews__search-reviews-form">
        <form onSubmit={onSubmit}>
          <Input
            placeholder="Search Reviews"
            id="search-input"
            value={searchText}
            onChange={(currentValue) => setSearchText(currentValue)}
          />
          <button
            id="search"
            className="review_search_button"
            type="submit"
            onClick={() => setSearchPillText(searchTerm)}
          />
        </form>
      </Col>
      <Col>
        {
          searchPillText
          && (
            <div>
              <span className="ratings-reviews__search-keyword">{noResults ? 'No results found' : 'Search By:'}</span>
              <Button
                key="search"
                id="search"
                onClick={() => setSearchPillText(null)}
                filter
              >
                {noResults && searchTerm ? 'Clear Search Term' : searchPillText}
              </Button>
            </div>
          )
        }
      </Col>

    </div>
  );
};

Search.displayName = 'RatingsAndReviewsSearch';

Search.propTypes = {
  noResults: bool,
  onSearch: func.isRequired
};

Search.defaultProps = {
  noResults: false,
}
